import { CASES } from './constants';

const initialState = {
    tasks: [],
    filterForm: {
        jobId: '',
        taskStatus: '',
    },
    selectedJob: '',
    isModalOpen: false,
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    rangeParam: [0, 19],
    defaultFilterRange: [0, 19],
    sortParam: ['id', 'DESC'],
    itemsPerPage: 15,
};

export function jobTasks(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_JOB_TASKS: {
            return { ...state, ...payload };
        }
        case CASES.UPDATE_JOB_TASKS_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_JOB_TASKS: {
            return initialState;
        }
        default:
            return state;
    }
}
